<template>
  <div class="row item_box product_card">
    <!-- {{list.pos}} -->
    <div class="imageview">
      <div class="viewform_images_list">
        <img
          class="justify-start item-box"
          style="width: 100%; object-fit: cover;"
          v-if="list.imageurl"
          alt="image"
          :src="list.imageurl"
        />
        <div v-else>
          <img
            class="noPreview"
            src="../assets/img/no_preview.png"
            alt="no_preview"
          />
          <p>{{ $t("newUi.adminViewform.noPreview") }}</p>
        </div>
      </div>
    </div>

    <!-- <div class="image_box justify-start" v-if="!list.imageurl"></div> -->
    <div class="col column-padding">
      <div class="item_text">
        <p>{{ list.name }}</p>
      </div>
      <read-more
        class="text_body"
        :more-str="$t('newUi.adminViewform.readMore')"
        :text="list.desc"
        link="#"
        :less-str="$t('newUi.adminViewform.readLess')"
        :max-chars="50"
      ></read-more>
      <div class="d-flex justify-space-between">
        <div class="item_text justify-start item_price">
          <span style="margin-right: 3px">{{ payload.symbol }}</span
          >{{ parseFloat(list.price).toFixed(2) }}
        </div>
        <div class="justify-end">
          <div
            class="text-end user_order_add_button1 cursor-pointer"
            v-if="list.qtty == 0"
            @click="incr_one(list.pos)"
          >
            <span>+ </span>
            <span>{{ $t("newUi.userFlow.add") }}</span>
          </div>
          <div class="text-end user_order_add_button1" v-if="list.qtty != 0">
            <span
              style="font-size: 15px; padding: 5px;  padding-left:10px; padding-right:10px"
              class="cursor-pointer"
              @click="dcr_one(list.pos)"
            >
              -
            </span>
            <span class="icon-space">{{ list.qtty }}</span>
            <span
              style="font-size: 15px; padding: 5px; padding-left:10px; padding-right:10px"
              class="cursor-pointer"
              @click="incr_one(list.pos)"
            >
              +
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="button-position">
            
            </div> -->
  </div>
</template>
<script>
import { setLocale } from "../services/firebase";
import i18n from "../i18n";
// import NumInp from "./NumInp"

export default {
  props: ["payload", "list"],
  // components: {
  //         NumInp
  //     },
  data() {
    return {
      dialog: false,
      edit_product: false,
      edit_category: false,
      delete_product: false,
      npayload: this.payload,
      nlist: this.list,
    };
  },
  mounted() {
    if (window.location.href.split("?")[1]) {
      if (window.location.href.split("?")[1].split("=")[1])
        i18n.locale = window.location.href.split("?")[1].split("=")[1];
      else setLocale();
    } else setLocale();
  },

  // computed: {
  //     typecheck: function() {
  //        return console.log("edit value" + this.edit_product)
  //     },
  // },
  methods: {
    recalc: function() {
      // console.log(this.list.qtty);
      if (this.list.qtty < 0) this.list.qtty = 0;
      // this.$emit("input", this.list.qtty);
      // this.recalcTotal();
      this.recalcTotal();
    },

    incr_one(pos) {
      if (this.list.qtty < 999) {
        for (var item of this.payload.catalogue) {
          if (item.pos == pos) {
            this.list.qtty += 1;
            break;

            // if (item.category != "") {
            //   item.qtty += 1;
            // }
          }
        }
        this.recalc();
      } else {
        alert(i18n.t("alertText.qttyLength"));
      }
    },
    dcr_one(pos) {
      for (var item of this.payload.catalogue) {
        if (item.pos == pos) {
          this.list.qtty -= 1;
          break;
          // if (item.category != "") {
          //   item.qtty -= 1;
          // }
        }
      }
      this.recalc();
    },
    setval: function(event) {
      this.list.qtty = event;
      // console.log(event);
      this.recalc();
    },
    recalcTotal: function() {
      var total = 0,
        tempTotal = 0,
        qty = 0,
        form = this.payload;
      // console.log("total form", form);

      for (var i = 0; i < form.catalogue.length; i++) {
        var curitem = form.catalogue[i];
        if (curitem.type !== "item") continue;
        if (curitem.isOrdered) {
          tempTotal += 1 * curitem.price;
          total = tempTotal.toFixed(2);
          qty += curitem.qtty;
        } else if (curitem.qtty > 0) {
          tempTotal += curitem.qtty * curitem.price;
          total = tempTotal.toFixed(2);
          qty += curitem.qtty;
        }
      }

      form.amount = total;
      document.getElementById("item").innerText = qty;
      document.getElementById("total").innerText = total;
      document.getElementById("Mob_item").innerText = qty;
      document.getElementById("Mob_total").innerText = total;
      this.payload.amount = total;
      // this.$store.dispatch('SET_AMOUNT',total);
      // console.log('current_amount',this.$store.state.current_amount,this.$store.state.current_count);
      // console.log(this.$store.state.currentForm.amount)
    },
  },
};
</script>
<style lang="scss">
.v-application p {
  margin-bottom: 0px;
}

/* .item_category {
    padding: 5px;
    margin: 2px;
    color: white;
    background-color: #8AB26D;
    border-radius: 5px;
} */
.bottom_modal {
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.button-position {
  position: relative;
  text-align: right;
  padding-top: 10%;
  bottom: -5px;
  right: -1px;
}
.text_bold {
  font-weight: 500;
}
.icon-space {
  padding: 0px 8px;
}
@media (min-width: 960px) {
  .item_category {
    padding: 5px;
    margin: 12px 0px;
    color: #fff;
    background-color: #31333e;
    border-radius: 5px;
  }
  .item_text {
    word-break: break-all;
    min-height: 35px;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #666666;
    opacity: 1px;
  }
  .text_body {
    min-height: 35px;
    font-size: 12px;
    letter-spacing: 0px;
    word-break: break-word;
    color: #666666;
  }
  #readmore {
    color: #8ab26d;
  }
  .user_order_add_button1 {
    font-size: 12px;
    font-weight: bold;
    background: #8ab26d 0% 0% no-repeat padding-box;
    padding: 5px 10px;
    border-radius: 5px;
    color: #fff;
  }
  .image_boxe {
    background-color: #f8faf7;
    margin: 2px;
  }
  .item_box {
    padding: 0px;
    margin: 2px;
    background-color: #f8faf7;
    border-radius: 5px;
  }
  .item_price {
    display: flex;
    align-items: flex-end;
    vertical-align: bottom;
  }
}
@media (min-width: 320px) and (max-width: 960px) {
  .item_category {
    padding: 5px;
    margin: 12px 0px;
    color: #fff;
    background-color: #8ab26d;
    border-radius: 5px;
  }
  .item_text {
    word-break: break-all;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #666666;
    opacity: 1px;
  }
  .text_body {
    font-size: 12px;
    letter-spacing: 0px;
    word-break: break-word;
    color: #666666;
  }
  .image_box {
    width: 70px;
    height: 70px;
  }
  #readmore {
    color: #8ab26d;
  }
  .user_order_add_button1 {
    font-size: 12px;
    background: #fff 0% 0% no-repeat padding-box;
    font-weight: bold;
    padding: 5px 10px;
    border-radius: 5px;
    color: #8ab26d;
  }
  .column-padding {
    padding-left: 10px;
    padding-top: 0px;
    padding-bottom: 0px;
    padding-right: 0px;
  }
  .image_boxe {
    background-color: #f8faf7;
  }
  .item_box {
    padding: 5px;
    margin: 2px;
    background-color: #f8faf7;
    border-radius: 5px;
  }
  .item_price {
    display: flex;
    align-items: flex-end;
    vertical-align: bottom;
  }
}
@media (min-width: 960px) {
  .image_box {
    max-width: 250px;
    /*width: 100%;*/
    max-height: 150px;
  }
}
@media (min-width: 960px) {
  .imageview {
    width: 100%;
    height: 150px;
    // display: flex;
    justify-content: center;
  }
}
.viewform_images_list {
  display: flex;
  align-items: center;
  justify-content: center;
}
.viewform_images_list {
  background: #fff;
}
.viewform_images_list div {
  text-align: center;
  padding: 13px 0;
}
.viewform_images_list div > img {
  max-width: 100px;
}
.viewform_images_list img {
  width: 100%;
  max-width: 100%;
}
.viewform_images_list div p {
  margin-top: 10px;
  font-size: 16px;
}
@media (max-width: 960px) {
  .viewform_images_list {
    max-width: 80px;
    height: 80px;
    background: #fff;
  }
  .viewform_images_list div {
    padding: 10px 10px;
  }
  .viewform_images_list img {
    // max-width: 22px;
  }
  .viewform_images_list div p {
    margin-top: 0;
    font-size: 8px;
  }
  .v-avatar.mobileview {
    width: 80px !important;
    height: auto !important;
  }

  .v-avatar.mobileview img {
    width: 100% !important;
    height: auto !important;
  }
}
.product_card .viewform_images_list {
  height: 500px;
}
@media (max-width: 1920px) {
  .product_card .viewform_images_list {
    height: 310px;
  }
}

@media (max-width: 1600px) {
  .product_card .viewform_images_list {
    height: 280px;
  }
}
@media (max-width: 1500px) {
  .product_card .viewform_images_list {
    height: 250px;
  }
}
@media (max-width: 1024px) {
  .product_card .viewform_images_list {
    height: auto;
  }
}
.text-end.user_order_add_button1 {
  display: flex;
  align-items: center;
}

.text-end.user_order_add_button1 span {
  padding: 0 5px !important;
}
.consumer-product .imageview div img.noPreview {
  max-width: 100px;
}
</style>
